import React from "react";
import Mail from "../../../Images/gmail.svg";
import Chat1 from "../../../Images/chat1.svg";
import learnimage from "../../../Images/learnimage.svg";
import screenshot from "../../../Images/Screenshot.svg";
import tick from "../../../Images/tick.svg";
import { useNavigate } from "react-router-dom";


const Courses = () => {
  const navigate = useNavigate();
  return (
    <section className="w-full bg-gray-50 py-20 px-6 md:px-20 flex flex-col lg:flex-row items-center gap-20">
      {/* LEFT SIDE */}
      <div className="relative w-full lg:w-1/2 h-[550px]">
        {/* Blue Background Accent */}
        <div className="absolute w-72 h-72 bg-sky-100 rounded-xl left-28 top-48 -z-10"></div>

        {/* Assignment Message Card */}
        <div className="absolute top-10 left-10 bg-white rounded-xl shadow-lg p-4 w-64 border">
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-lime-600 w-6 h-6 rounded-md" />
            <img src={Chat1} alt="Chat icon" />
            <span className="text-emerald-700 text-xs font-semibold">
              Assignment Message
            </span>
          </div>
          <p className="text-[10px] text-gray-900 leading-5">
            Hi Rita, <br />
            Today 10:30 am William's Assignment has been rescheduled at 4:00 pm.
          </p>
        </div>

        {/* Reports Card */}
        <div className="absolute top-32 right-0 bg-white rounded-xl shadow-lg p-4 w-64 border">
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-orange-100 w-5 h-5 rounded flex items-center justify-center">
              <img src={Mail} alt="mail" className="w-3 h-3" />
            </div>
            <span className="text-emerald-700 text-xs font-semibold">
              Reports
            </span>
          </div>
          <p className="text-xs font-semibold text-gray-900">
            Staff Daily Reports
          </p>
          <p className="text-xs text-gray-700 mt-1">
            Yesterday Reports — 14 Dec 20XX
          </p>
          <img
            src={screenshot}
            className="mt-3 w-full h-20 object-cover rounded-md"
          />
        </div>

        {/* Profile Image */}
        <div className="absolute top-56 left-[180px] w-52 h-64 rounded-xl overflow-hidden shadow-lg">
          <img src={learnimage} className="w-full h-full object-cover" />
        </div>

        {/* Negative Feedback Card */}
        <div className="absolute top-[330px] left-10 bg-white rounded-xl shadow-lg p-4 w-72 border">
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-orange-100 w-5 h-5 rounded flex items-center justify-center">
              <img src={Mail} className="w-3 h-3" />
            </div>
            <span className="text-amber-500 text-xs font-semibold">
              Negative Feedback
            </span>
          </div>
          <div class="w-36 h-5 relative">
            <div class="w-5 h-5 left-0 top-0 absolute overflow-hidden">
              <div class="w-5 h-4 left-0 top-[0.34px] absolute bg-yellow-500"></div>
            </div>
            <div class="w-5 h-5 left-[31.45px] top-0 absolute rounded-md"></div>
            <div class="w-5 h-5 left-[62.90px] top-0 absolute rounded-md"></div>
            <div class="w-5 h-5 left-[94.36px] top-0 absolute rounded-md"></div>
            <div class="w-5 h-5 left-[125.81px] top-0 absolute rounded-md"></div>
          </div>
          <p className="text-xs text-gray-800 mb-1">
            One student posted the feedback.
          </p>
          <p className="text-[11px] font-medium text-gray-900">
            Disappointing salon experience
          </p>
          <p className="text-[11px] text-gray-700 mt-1">
            Rude staff, poor service, and overpriced. Won't return — find better
            options elsewhere for quality service.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE CONTENT */}
      <div className="w-full lg:w-1/2 text-left">
        <h4 className="uppercase text-teal-800 text-sm font-medium tracking-wider mb-2">
          About SkillMD
        </h4>

        <h2 className="text-4xl font-bold leading-[48px] text-slate-700">
          Learn Practical <br />
          <span className="text-[#F2542D]">Medical Skills</span>
        </h2>

        <p className="text-gray-700 text-lg leading-8 mt-6 mb-8 w-[90%]">
          Lorem Ipsum is simply dummy text of the printing and type setting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since then.
        </p>

        <ul className="space-y-4 text-neutral-700 text-lg leading-8 mb-8">
          <li className="flex items-start gap-3">
            <img src={tick} className="w-5 h-5 mt-1" />
            <span>Get unlimited access to 66000+ of our top Programs</span>
          </li>
          <li className="flex items-start gap-3">
            <img src={tick} className="w-5 h-5 mt-1" />
            <span>Explore a variety of fresh educational topics</span>
          </li>
          <li className="flex items-start gap-3">
            <img src={tick} className="w-5 h-5 mt-1" />
            <span>Find the best qualified teacher for you</span>
          </li>
        </ul>

        <button className="bg-cyan-500 text-white font-semibold text-sm px-6 py-3 rounded uppercase hover:bg-teal-600 transition"
         onClick={() => navigate("/courses")}>
          View All Programs
        </button>
      </div>
    </section>
  );
};

export default Courses;
